<template>
  <p v-if="showPrezzo">
    <wizard-price-tag :product="product" :product-instead="productInstead" :qt="askQt ? qt : undefined" />
  </p>
  <p v-if="showUtenti">
    {{ $t('Licenza per {0} utenti', [product.utenti]) }}
  </p>
  <input v-if="groupRequired !== undefined" type="checkbox" :checked="groupRequired" required class="required-hidden" />
  <pf-switch
    :checked="modelValue"
    :required="required"
    :value="true"
    off-value="0"
    :label="modelValue ? onText : offText"
    @update:checked="emit('update:modelValue', $event)"
    :ouia-id="`switch-${name}`"
  />

  <div v-if="askQt && modelValue" style="max-width: 300px">
    <label>
      {{ $t('Quantità:') }}
      <x-input
        type="number"
        name="qt"
        required
        :min="1"
        :model-value="qt"
        @update:model-value="emit('update:qt', Number($event))"
        :disabled="fixedQt"
        :ouia-id="`input-qt-${name}`"
      >
        <template #append>
          <pf-input-group-text class="pf-v6-u-text-nowrap">
            <template v-if="qtStep">{{ qtStep }} </template>
            {{ um }}
          </pf-input-group-text>
          <pf-input-group-text v-if="qtStep > 1" plain class="pf-v6-u-text-nowrap"> {{ qtStep * qt }} {{ um }} </pf-input-group-text>
        </template>
      </x-input>
    </label>
  </div>
</template>

<style scoped>
.required-hidden {
  position: relative;
  width: 1px;
  height: 1px;
  left: 25px;
}
</style>

<script setup lang="ts">
import { $t as _t } from '@/i18n';
import { useWizardQuestion, type ProductPriceInfo } from '@/wizard';
import WizardPriceTag from '../wizard-price-tag.vue';

defineOptions({
  inheritAttrs: false,
});

withDefaults(
  defineProps<{
    modelValue: boolean;
    required?: boolean;
    groupRequired?: boolean;
    showPrezzo?: boolean;
    showUtenti?: boolean;
    product: ProductPriceInfo;
    productInstead?: ProductPriceInfo;
    onText?: string;
    offText?: string;
    askQt?: boolean;
    qt?: number;
    fixedQt?: boolean;
    qtStep?: number;
    um?: string;
    name?: string;
  }>(),
  {
    qt: 1,
    qtStep: 1,
    onText: _t('Sì'),
    offText: _t('No'),
    groupRequired: undefined,
  },
);

const emit = defineEmits<{
  (name: 'update:modelValue', v: boolean): void;
  (name: 'update:qt', v: number): void;
}>();

useWizardQuestion();
</script>
